var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerksDiscounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.086 4.31l2.85 8.042a2.572 2.572 0 003.524 1.46l7.718-3.662a2.55 2.55 0 013.407 3.407l-3.662 7.718a2.574 2.574 0 001.46 3.523l8.042 2.851a2.573 2.573 0 010 4.844l-8.042 2.85a2.574 2.574 0 00-1.46 3.524l3.662 7.764a2.572 2.572 0 01-3.407 3.43l-7.718-3.685a2.573 2.573 0 00-3.523 1.46l-2.851 8.066a2.572 2.572 0 01-4.844 0l-2.85-8.112a2.572 2.572 0 00-3.524-1.46l-7.764 3.685a2.573 2.573 0 01-3.384-3.384l3.685-7.718a2.573 2.573 0 00-1.46-3.523l-8.112-2.897a2.572 2.572 0 010-4.844l8.112-2.85a2.574 2.574 0 001.46-3.524l-3.685-7.718a2.573 2.573 0 013.384-3.407l7.718 3.662a2.574 2.574 0 003.523-1.46l2.897-8.042a2.573 2.573 0 014.844 0z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.305 25.78a2.318 2.318 0 100-4.634 2.318 2.318 0 000 4.635zM35.576 39.687a2.318 2.318 0 100-4.635 2.318 2.318 0 000 4.635zM37.894 23.464L23.987 37.37",
    stroke: "#000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconPerksDiscounts;